import { render } from "./MatchPage.vue?vue&type=template&id=a3532fb8&ts=true"
import script from "./MatchPage.vue?vue&type=script&lang=ts"
export * from "./MatchPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Matches/MatchPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3532fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3532fb8', __exports__)) {
    api.reload('a3532fb8', __exports__)
  }
  
  module.hot.accept("./MatchPage.vue?vue&type=template&id=a3532fb8&ts=true", () => {
    api.rerender('a3532fb8', render)
  })

}


export default __exports__